import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/policy/img/block1_icon_搜索.png")